'use client';

import Text, { TEXT_VARIANT } from '@pixum/text';
import RightArrow from '@pixum/svg-icon/lib/Arrows/ForwardIos';
import type { TextLinkListProps } from './types';
import { useState, type CSSProperties } from 'react';
import { TextLink } from './TextLink';
import clsx from 'clsx';

export function TextLinkList(props: TextLinkListProps) {
  const { align, direction, flow, links, title, type, expanded } = props;
  // Check state
  const [checked, setChecked] = useState(expanded);
  const customProperties = {
    '--footer-links-list-item-align': align,
    '--footer-links-list-item-direction': direction,
    '--footer-links-list-item-flow': flow
  } as CSSProperties;

  return (
    <section className="footer__links-list-section variant-text collapsible" id={type}>
      <Text className="footer__links-list-heading" variant={TEXT_VARIANT.HEADLINE}>
        {title}
      </Text>
      <input
        id={`footer-links-list-collapsible-${type}`}
        type="checkbox"
        defaultChecked={!!expanded}
        onChange={() => setChecked(!checked)}
      />
      <label
        className={clsx('footer__links-list-label', checked && 'expanded')}
        htmlFor={`footer-links-list-collapsible-${type}`}
      >
        <span>{title}</span>
        <RightArrow />
      </label>
      <ul className={clsx('footer__links-list', checked && 'expanded')} style={customProperties}>
        {links.map((link, index) => (
          <li className="footer__links-list-item" key={`footer-text-link-${type}-${index}`}>
            <TextLink {...link} />
          </li>
        ))}
      </ul>
    </section>
  );
}
